'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('../wishlistHeart'));
    processInclude(require('../quickView'));
    processInclude(require('../../components/scrollme'));
});
